<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.push('/admin/users/toevoegen')" class="pull-right"
                      v-can="'gebruikers aanpassen'">Gebruiker toevoegen
            </b-button>
            <b-button v-b-modal.import-modal class="pull-right mr-2" v-can="'gebruikers aanpassen'">Importeren
            </b-button>
          </b-col>
        </b-row>
        <resource-index header="Gebruikers" endpoint="users" show-route="users.view"/>
      </div>
    </div>
    <b-modal id="import-modal" ref="import" title="Importeren" hide-footer>
      <p class="mb-4">
        Importeer gebruikers aan de hand van een .XLSX document met daarin de volgende kolommen:
      </p>
      <b-list-group class="mt-0 mb-4">
        <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">1. Naam</b-list-group-item>
        <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">2. E-mail</b-list-group-item>
        <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">3. Gebruikersrol</b-list-group-item>
        <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">4. Bedrijfsnaam</b-list-group-item>
        <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">5. Locatienaam</b-list-group-item>
        <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">6. Versturen activatielink (ja/nee)</b-list-group-item>
      </b-list-group>

      <b-alert show variant="warning"><b>Let op:</b> gebruikers ontvangen iedere keer dat kolom 6 op "ja" staat een activatielink.</b-alert>
      <b-form id="upload-form" @submit.prevent="importUsers">
        <b-form-file v-model="importFile" :state="Boolean(importFile)" accept=".xls, .xlsx, .csv, .txt"
                     placeholder="Kies of sleep een bestand..." drop-placeholder="Sleep het bestand..."/>
        <b-row class="mt-2">
          <b-col>
            <hr>
            <b-button type="submit" :disabled="!importFile" block class="mt-4" variant="primary">Importeer
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
  import ResourceIndex from '../../components/ResourceIndex';
  import {uploadData} from "../../api";

  export default {
    name: 'users',
    components: {ResourceIndex},
    data() {
      return {
        importFile: undefined,
      }
    },
    computed: {
      userRole() {
        return this.$store.state.userRole
      }
    },
    methods: {
      async importUsers() {
        let data = new FormData();
        const file = this.importFile;
        data.append('file', file);

        const response = await uploadData('users/import', data);

        if (response.status === 422) {
          this.$bvToast.toast(`${response.data.errors[0][0]}`, {
            title: 'Oeps...',
            noAutoHide: true,
            variant: 'danger',
          });
        } else if (response.status !== 200) {
          this.$bvToast.toast(`Er is iets fout gegaan tijdens het importeren: ${response.data.message}`, {
            title: 'Oeps...',
            autoHideDelay: 5000,
            variant: 'danger',
          });
        } else if (response.status === 200) {
          this.$bvToast.toast(`Importeren van gebruikers is gelukt`, {
            title: 'Succes',
            autoHideDelay: 5000,
            variant: 'success',
          });
        }

        this.importFile = undefined;
        this.$refs['import-modal'].hide();
      },
    }
  }
</script>
